/** Sends a request to an API and converts the response into a JSON object */
async function fetchJson(endpoint, settings) {
    const resp = await fetch(endpoint, settings);
    return (await resp.json());
}
/** Builds a `RequestInit` object for use with GET requests using the Fetch API */
function getRequestOptions(credentials, csrf) {
    const headers = csrf !== null
        ? {
            'Content-Type': 'application/json',
            'Csrf-Token': csrf.token ?? '',
        }
        : {
            'Content-Type': 'application/json',
        };
    return {
        method: 'GET',
        headers,
        credentials,
    };
}
/** Builds a `RequestInit` object for the Fetch API */
function requestOptions(data, credentials, method, csrf) {
    return {
        ...getRequestOptions(credentials, csrf),
        method,
        body: JSON.stringify(data),
    };
}
export { fetchJson, getRequestOptions, requestOptions };
